export enum SeverityEnum {
  Error = 'error',
  Info = 'info',
  Note = 'note',
  Success = 'success',
  Warning = 'warning',
}
